import { node } from "prop-types";
import { forwardRef, useContext } from "react";

import styled from "styled-components";
import { marginBottom } from "theme";

import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap";

import { FnrAccordionContext } from "./FnrAccordion";
import { getMarginCorrectionAmount } from "./utils";

const SFnrVerticalGap = styled(FnrVerticalGap)`
  ${({ $marginCorrection, $marginCorrectionAmount }) =>
    $marginCorrection ? `margin: 0 -${$marginCorrectionAmount}px;` : ""}
  ${marginBottom}
  transition: margin .3s, background-color .3s, gap .3s;
`;

const Container = forwardRef(({ children, ...rest }, ref) => {
  const { addCard, active, cardIsShowing, marginCorrection, noActiveMargin } =
    useContext(FnrAccordionContext);
  return (
    <SFnrVerticalGap
      gap={active ? 8 : 0}
      $variant="accordion"
      $active={active}
      $noActiveMargin={
        noActiveMargin ||
        addCard /* if addCard, this will be applied to CardRelay already */
      }
      $marginCorrection={marginCorrection && !cardIsShowing}
      $marginCorrectionAmount={getMarginCorrectionAmount(marginCorrection)}
      data-cy="FnrAccordion_Container"
      ref={ref}
      {...rest}
    >
      {children}
    </SFnrVerticalGap>
  );
});

Container.propTypes = { children: node };
export default Container;
